import api from '@pray/shared/utils/api';

import type { RecurringCampaignDetail, RecurringCampaignStatusChangeTarget } from './types';

// PATCH …/campaigns/recurring/:id/status — Activate / Stop / Resume.
// Resume is `stopped → active`; the server runs activation readiness on every
// `→ active` transition. Returns the refreshed detail DTO.
export async function changeRecurringCampaignStatus({
  artistId,
  recurringCampaignId,
  targetStatus,
}: {
  artistId: string;
  recurringCampaignId: string;
  targetStatus: RecurringCampaignStatusChangeTarget;
}): Promise<{ object: RecurringCampaignDetail }> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!recurringCampaignId) throw new Error('Recurring campaign ID is required');

  const url = `/web/studio/artists/${artistId}/campaigns/recurring/${recurringCampaignId}/status`;
  const response = await api.executePatchRequest<{ data: { object: RecurringCampaignDetail } }>(url, {
    target_status: targetStatus,
  });
  return response.data.data;
}
